import script from "./editorLaudo.vue?vue&type=script&setup=true&lang=js"
export * from "./editorLaudo.vue?vue&type=script&setup=true&lang=js"

import "./editorLaudo.vue?vue&type=style&index=0&id=1bc61a85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc61a85"]])

export default __exports__